// src/resources/sections/wikiConfig.ts
import type { ResourceConfig } from "../resourceTypes";

export const WIKI_CONFIG: ResourceConfig[] = [
  {
    name: "pages",
    label: "Pages",
    schema: "wiki",
    fields: [
      {
        source: "path",
        label: "path",
        kind: "text",
        list: true,
        form: true,
      },
      {
        source: "title",
        label: "title",
        kind: "text",
        list: true,
        form: true,
      },
    ],
    searchFields: ["path", "title"],
  },
];
